/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import { ScoreBars } from './ScoreBars';
import styles from './Tiers.module.scss';

const tiers = [
  {
    name: 'Elite',
    color: '#E5243E',
    barNumber: 4,
    items: [
      'Global leaders in their field',
      'Publish in medical journals frequently',
      'Speak at conferences',
      'Participate in clinical trials',
      'Likely to work with cutting edge treatments',
      'Likely to hold leadership positions in their organization',
    ],
  },
  {
    name: 'Distinguished',
    color: '#810196',
    barNumber: 3,
    items: [
      'Leaders in their field',
      'Strong research portfolio',
      'Likely to work with cutting edge treatments',
      'Likely to be a leader in their field regionally',
    ],
  },
  {
    name: 'Advanced',
    color: '#022172',
    barNumber: 2,
    items: [
      'Excellent at diagnosing and treating conditions.',
      'Treat many patients and have extensive experience in their field.',
      'May not publish, speak at conferences, or participate in clinical trials.',
    ],
  },
  {
    name: 'Experienced',
    color: '#4062BB',
    barNumber: 1,
    items: [
      'Primarily treat patients rather than focus on research.',
      'May be specialists or primary care physicians.',
      'Have great experience in diagnosing and treating conditions.',
      'Majority of doctors fall within this level of expertise.',
    ],
  },
];

const Tiers = ({ className }) => {
  return (
    <div className={classNames(styles['tiers-container'], className)}>
      <div className={styles['title']}>Learn about our doctor expertise tiers.</div>
      <div className={styles['sub-title']}>
        If you have a rare or serious condition, you may want to seek advice from the best doctor you can find.
      </div>
      <div className={styles['sub-title']}>In most cases, seeking advice from top-tier doctors may not be necessary.</div>
      <div className={styles['tiers-wrapper']}>
        {tiers.map(({ name, color, items, barNumber }, i) => (
          <div key={i} style={{ color }} className={styles['tier-wrapper']}>
            <div className={styles['tier-title']}>{name}</div>
            <ScoreBars designatedTier={barNumber} />

            <ul className={styles['tier-ul']}>
              {items.map((item, i) => (
                <li key={i}>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export { Tiers as default, Tiers };
